export default "__VITE_ASSET__9118f80a__"